import React from 'react';
import {useTranslation} from 'react-i18next';
import ClientInfoUnit from './ClientInfoUnit';
import styles from './ClientInfoColumn.module.css';
import {ClientCardType} from '../../../../../types/TypesUser';

interface ClientInfoColumnSecondProps {
	data: ClientCardType;
}

const ClientInfoColumnSecond: React.FC<ClientInfoColumnSecondProps> = ({
	data,
}) => {
	const {t} = useTranslation();
	return (
		<div className={styles.clientInfoColumn}>
			<ClientInfoUnit label={t('Дата Реєстрації')} value={data.registration_date} />
			<ClientInfoUnit label={t('Кваліфікація')} value={data.qlfcname} />
			<ClientInfoUnit label="Маркетинг-план" value={data.marketplan} />
			<ClientInfoUnit label={t('Клієнтів в дереві')} value={data.count_user_tree} />
		</div>
	);
};

export default ClientInfoColumnSecond;
